export enum SurveyQuestionOptionType {
    Radio,
    Star,
}
